// src/components/HeroSection.jsx
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import "./HeroSection.css";
import heroBg from "../assets/hero-bg2.png";
import { MODE } from "../config/compliance";
import { LangContext } from "../lang/LangProvider";
import { useAnalytics } from "../hooks/useAnalytics";
import MailingListModal from "./MailingListModal";

const HeroSection = () => {
  const { lang } = useContext(LangContext);
  const { trackCTAClick } = useAnalytics();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const title =
    lang === "en"
      ? <>Quantitative, data-driven<br /> methods for the markets</>
      : <>Metodi quantitativi e data-driven<br /> per i mercati</>;

  const subtitle =
    lang === "en"
      ? "Research, models and tools — transparent about method and limits. Informational and educational content and simulation tools."
      : "Ricerca, modelli e strumenti — con trasparenza su metodo e limiti. Contenuti informativi, educativi e strumenti di simulazione.";

  const eduNote =
    lang === "en"
      ? "Educational content. No personalized financial advice."
      : "Contenuti educativi. Nessuna consulenza finanziaria personalizzata.";

  // Nota anche in POST (l'hero in POST non aveva alcuna avvertenza — rilievo audit 13/07)
  const postNote =
    lang === "en"
      ? "Past returns are not indicative of future ones. Investment decisions remain yours."
      : "I rendimenti passati non sono indicativi di quelli futuri. Le decisioni di investimento restano tue.";

  const ctaNewsletterLabel =
    lang === "en" ? "Subscribe to updates" : "Iscriviti agli aggiornamenti";
  // POST: il secondo pulsante porta ai contenuti, non a un contatto commerciale
  // (servizio di consulenza non avviato — revisione 29/09/2026).
  const ctaContentLabel =
    lang === "en" ? "Explore the Knowledge Base" : "Esplora la Knowledge Base";

  const openModal = (label) => {
    trackCTAClick(label, "mailing-list-modal", MODE);
    setIsModalOpen(true);
  };

  return (
    <>
      <section className="hero" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">{title}</h1>
          <p className="hero-subtitle">{subtitle}</p>

          <div className="hero-cta-wrap">
            {/* EDU e PRE: newsletter modal + nota educativa */}
            {(MODE === "EDU" || MODE === "PRE") && (
              <>
                <button
                  className="hero-btn primary"
                  onClick={() => openModal(ctaNewsletterLabel)}
                >
                  {ctaNewsletterLabel}
                </button>
                <div className="hero-note">{eduNote}</div>
              </>
            )}

            {/* POST (servizio non avviato): contenuti + aggiornamenti */}
            {MODE === "POST" && (
              <>
                <Link
                  to={`/${lang}/kb`}
                  className="hero-btn primary"
                  onClick={() => trackCTAClick(ctaContentLabel, "kb", MODE)}
                >
                  {ctaContentLabel}
                </Link>
                <button
                  className="hero-btn secondary"
                  onClick={() => openModal(ctaNewsletterLabel)}
                >
                  {ctaNewsletterLabel}
                </button>
                <div className="hero-note">{postNote}</div>
              </>
            )}
          </div>
        </div>
      </section>

      <MailingListModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default HeroSection;
